module.exports = "/_next/static/images/31b6d526e1e5c4ec003f283af367e5b7-card-background-right-xs.jpg";